import { AgEditorComponent } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { TextInputComponent } from '@hs/ui-core-inputs';

@Component({
    selector: 'app-mo-trade-release-comment-cell-editor',
    styleUrls: ['./mo-trade-release-comment-cell-editor.component.scss'],
    templateUrl: './mo-trade-release-comment-cell-editor.component.html',
    imports: [
        TextInputComponent,
    ],
})
export class MoTradeReleaseCommentCellEditorComponent implements AgEditorComponent, AfterViewInit {
    @ViewChild('input', { static: false, read: ElementRef }) input: ElementRef | undefined;
    protected value = '';

    agInit(params: Partial<ICellRendererParams>): void {
        this.value = params.value ?? '';
    }

    getValue(): string {
        return this.value;
    }

    ngAfterViewInit(): void {
        // This solution is from the Ag-grid documentation.
        // Sometimes the cell does not get focused when clicking,
        // so we need to manually focus it
        window.setTimeout(() => {
            const input = this.input?.nativeElement.querySelector('input');
            input?.focus();
            input?.setSelectionRange(0, this.value.length);
        });
    }
}
